import Loader from "./Loader";
import clsx from "clsx";
import React from "react";
export default function Button({ type, children, className, disabled, loading, theme = "blue", onClick, }) {
    if (theme === "otomoto") {
        return (<button type={type} className={clsx(className, "bg-[#306fc6] text-white flex items-center justify-center border-0 h-[50px] rounded px-5")} disabled={disabled || loading} onClick={onClick}>
        {loading ? <Loader /> : children}
      </button>);
    }
    let themeClassName = clsx("flex items-center justify-center border-0 h-[50px] rounded-full px-5 transition cursor-pointer", className);
    if (theme === "gray") {
        themeClassName = clsx(themeClassName, "bg-[#ebecef] text-black");
    }
    else if (theme === "blue") {
        themeClassName = clsx(themeClassName, "bg-[#0071CE] text-white focus:bg-[#005ca8] hover:bg-[#005ca8]");
    }
    return (<button type={type} className={themeClassName} disabled={disabled || loading} onClick={onClick}>
      {loading ? <Loader /> : children}
    </button>);
}
